module.exports = __webpack_public_path__ + "img/bg1.8b1568a3.jpg";